const __filename = "/app/components/cms/profile_actions/ns.js", __dirname = "/app/components/cms/profile_actions";
import WebComponent from '@rubygems/hue/app/components/web_component'

// The only thing a profile's action row needs a script for: the Go Back button under the portrait.
// Live writes it as `<a onclick="history.back()">` with no href — see ns.rb for why that is a
// button here instead.
//
// The button is hidden by the stylesheet until this marks the element ready, so a reader whose
// JavaScript never runs meets no dead control. Everything else in the row is a plain link and
// needs nothing from here.
WebComponent.register(
  class extends WebComponent {
    // Named to match `extend Hue::Phlex::CustomElement(:profile_actions)` rather than derived from
    // this filename, which would make it `components-cms-profile-actions-ns`.
    static componentName = 'profile-actions'

    connectedCallback() {
      const back = this.querySelector('[data-back]')
      if (!back) return

      back.addEventListener('click', () => history.back())
      this.dataset.ready = ''
    }
  }
)
